import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getPoList = createAsyncThunk(
  "get-po",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("purchase-order/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createPo = createAsyncThunk(
  "create-po",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("purchase-order", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editPo = createAsyncThunk(
  "edit-po",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`purchase-order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updatePo = createAsyncThunk(
  "update-po",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`purchase-order/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deletePo = createAsyncThunk(
  "delete-po",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`purchase-order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const poSlice = createSlice({
  name: "po",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPoList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPoList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.purchaseOderList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getPoList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default poSlice.reducer;
